// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","466":"component---src-pages-docs-mdx-slug-js"}[chunkId] + "-" + {"125":"d948df6ffc2a2bd814b0","293":"4d11be7ab70ad65f8d0e","466":"89b17926432c9fab9c2c"}[chunkId] + ".js";
};